var _path, _path2, _ellipse, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 0H16.5C20.6415 0 24 3.3112 24 7.39437V16.2676C24 20.3508 20.6415 23.662 16.5 23.662H7.5C3.3585 23.662 0 20.3508 0 16.2676V7.39437C0 3.3112 3.3585 0 7.5 0ZM16.5 21.4437C19.395 21.4437 21.75 19.1218 21.75 16.2676V7.39437C21.75 4.54014 19.395 2.21831 16.5 2.21831H7.5C4.605 2.21831 2.25 4.54014 2.25 7.39437V16.2676C2.25 19.1218 4.605 21.4437 7.5 21.4437H16.5Z",
    fill: "url(#paint0_linear_1065_656)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 11.831C6 8.56419 8.6865 5.91553 12 5.91553C15.3135 5.91553 18 8.56419 18 11.831C18 15.0979 15.3135 17.7465 12 17.7465C8.6865 17.7465 6 15.0979 6 11.831ZM8.25 11.831C8.25 13.8689 9.933 15.5282 12 15.5282C14.067 15.5282 15.75 13.8689 15.75 11.831C15.75 9.79165 14.067 8.13384 12 8.13384C9.933 8.13384 8.25 9.79165 8.25 11.831Z",
    fill: "url(#paint1_linear_1065_656)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.4499,
    cy: 5.47183,
    rx: 0.7995,
    ry: 0.788239,
    fill: "url(#paint2_linear_1065_656)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1065_656",
    x1: 12.0001,
    y1: 31.161,
    x2: 31.3281,
    y2: 11.5567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC107"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#F44336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#9C27B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1065_656",
    x1: 12,
    y1: 20.1966,
    x2: 20.3647,
    y2: 11.7124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC107"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#F44336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#9C27B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1065_656",
    x1: 18.45,
    y1: 6.58661,
    x2: 19.5645,
    y2: 5.45602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC107"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#F44336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#9C27B0"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.bfaabe6df0f978b379036786915f720c.svg";
export { ForwardRef as ReactComponent };